import React from 'react'
import { Card, CardBody, Col } from 'reactstrap'
import { H1, Image, P } from '../../../../AbstractElements'
import { Link } from 'react-router-dom'
import { animateImageList } from '../../../../Data/DashboardsData/DefaultData'
import { dynamicImage } from '../../../../Utils'

export default function WelcomeCard() {
    return (
        <Col xxl={5} md={4} sm={6} className="box-col-4">
            <Card className="welcome-card">
                <CardBody>
                    <div className="d-flex">
                        <div className="flex-grow-1">
                            <H1>{'Good day, Lena Miller'}</H1>
                            <P>{'Welcome to the Admin clan! We appreciate your interest in our dashboard.'}</P>
                            <Link className="btn" to={`${process.env.PUBLIC_URL}/applications/ecommerce/product-list`}>{'Go Premium'}</Link>
                        </div>
                        <div className="animate-img">
                            {animateImageList.map((item, index) => (
                                <Image key={index} src={dynamicImage(`dashboard/${item}.png`)} alt="" />
                            ))}
                        </div>
                        <div className="flex-shrink-0">
                            <Image src={dynamicImage(`dashboard/welcome.png`)} alt="" />
                        </div>
                    </div>
                </CardBody>
            </Card>
        </Col>
    )
}